import Seo from './Seo';
import ContactForm from './ContactForm';
import '../styles/Contact.css';

const Contact: React.FC = () => {
  return (
    <main>
    <Seo
      title="Contact HICO — Start Your Project"
      description="Get in touch with HICO to start a website, ecommerce store, or design project. Tell us what you're building and we'll get back to you."
      path="/contact"
    />
    <div><h1 className="pageTitle">Contact Us</h1> </div>
      <div className="contactWrap">
        <div className="contact-content">
          <ContactForm />
        </div>
        <aside>Protected by reCAPTCHA</aside>
      </div>
    </main>
  );
};

export default Contact;
